// import { NavigationBar } from "../../components/font-end/MasterLayout/NavigationBar";
import { Profile } from '../../components/font-end/Profile/Profile';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { SalaryRequestDetail } from '../../components/font-end/SalaryRequest/SalaryRequesDetail';
// import { ComingSoon } from "../../components/font-end/MasterLayout/ComingSoon";
// import "../../../src/scss/App.scss";
import { useUser } from '../../context/UserContext';

export const SalaryRequest = (props: any) => {
          const { isLoading } = useUser();
      
        if (isLoading) {
          return (
            <div className="loading-pages text-center" style={{ backgroundColor: '#f0f0f0' }}>
              <div className="layout-loading">
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
          );
        }
  return (
    <>
      <Profile />
      <Menubar />
      <SalaryRequestDetail />
      {/* <ComingSoon /> */}
    </>
  );
};
